import { AppState } from 'store/root.reducer'

export const selectNewsState = (state: AppState) => state?.news

export const selectNews = (state: AppState) => selectNewsState(state)?.news

export const selectLoadingGetNewsStatus = (state: AppState) => selectNewsState(state)?.loadingGetNews
